import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { router } from '@/client/router';
import { CartProvider } from '@/features/cart/CartContext';
import { UIProvider } from '@/client/ui/UIContext';
import { I18nProvider } from '@/client/i18n/I18nContext';
import { ConsentProvider } from '@/client/consent/ConsentContext';
import '@/styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <I18nProvider>
      <ConsentProvider>
        <UIProvider>
          <CartProvider>
            <RouterProvider router={router} />
          </CartProvider>
        </UIProvider>
      </ConsentProvider>
    </I18nProvider>
  </React.StrictMode>,
);
